import React, { Component } from "react";
import Helmet from "react-helmet";
import { graphql, Link } from "gatsby";
/* import GitHubButton from 'react-github-btn'; */
import Layout from "../layout";
import PostListing from "../components/PostListing";

import nn from "../images/nn.png";
import nn2 from "../images/nn2.png";
/* import ProjectListing from '../components/ProjectListing'; */
/* import SimpleListing from '../components/SimpleListing'; */
import SEO from "../components/SEO";
import config from "../../data/SiteConfig";

import twitterIcon from "../../content/thumbnails/twitter-32.png";
import facebookIcon from "../../content/thumbnails/facebook-32.png";
/* import youtubeIcon from '../../content/thumbnails/youtube-32.png'; */
import mainthumb from "../images/diversity.png";
import team0 from "../images/rami.jpg";
import team1 from "../images/duaa.jpg";
import team2 from "../images/hiba.jpg";
import team3 from "../images/ashraf.jpg";
import team4 from "../images/seema.jpg";
import team5 from "../images/ola.jpg";
import team6 from "../images/amr.jpg";
import Muxg4oO from "../images/Muxg4oO.jpg";
import { css } from "@emotion/core";

import flutter from "../../content/thumbnails/logo_flutter.png";

export default class Index extends Component {
  render() {
    const backgroundStyles = css`
      background-image: url(${Muxg4oO});
    `;
    const teamimages = [team0, team4, team2, team3, team1, team5, team6];
    const { data } = this.props;
    const latestPostEdges = data.latest.edges;
    const popularPostEdges = data.popular.edges;

    return (
      <Layout>
        <Helmet title={`${config.siteTitle}`}>
          {" "}
          <html lang="ar" />{" "}
        </Helmet>
        <SEO />
        <div className="container">
          <div className="lead">
            <div className="elevator">
              <h1 className="h1home">نادي الطلبة المطورين</h1>
              <p className="h3home">جامعة النجاح الوطنية</p>
              <p>
                هي مجموعات مجتمعية للطلاب من أي خلفية أكاديمية في فترة الدراسة
                الجامعية أو الدراسات العليا. من خلال الانضمام إلى نوادي الطلبة
                المطورين، يقوم الطلاب ببناء شبكتهم المهنية والشخصية ، والوصول
                إلى موارد مطوري البرامج ، والعمل معًا لبناء حلول للمشاكل المحلية
                في بيئة تعليمية من نظير إلى نظير.
              </p>
              <div className="social-buttons">
                <div>
                  <a
                    href="https://www.twitter.com/DSCNAJAH"
                    title="حساب النادي على تويتر"
                    rel="noreferrer"
                    target="_blank"
                  >
                    <img
                      src={twitterIcon}
                      alt="حساب النادي على تويتر"
                      width="32px"
                      height="32px"
                    />
                  </a>
                </div>
                <div>
                  <a
                    href="https://www.facebook.com/DSCNAJAH"
                    title="حساب النادي على فيسبوك"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src={facebookIcon}
                      alt="حساب النادي على فيسبوك"
                      width="32px"
                      height="32px"
                    />
                  </a>
                </div>
              </div>
            </div>
            <div className="thumbmain">
              <img src={mainthumb} alt="Italian Trulli"></img>
            </div>
          </div>
        </div>

        <div className="container front-page">
          <div className="connectout">
            <div className="shifting"></div>

            <div className="connect">
              <p className="centered"> اتَّصل و طوِّر و انمُ ...</p>
              <p>
                قابل طلاب اخرين مهتمين بالتطوير باستخدام احدث التقنيات ، نرحب
                بجميع الطلاب من مختلف الخلفيات والتخصصات ، نساعدك للتعرف على
                مجموعة واسعة من المواضيع التقنية حيث يتم اكتساب مهارات جديدة من
                خلال ورش العمل والتدريب الشخصي وأنشطة بناء المشاريع عن طريق
                تطبيق ما تعلمته لبناء حلول رائعة للمشكلات المحلية.
              </p>
              <p>
                طور مهاراتك و وظيفتك و شبكتك الإجتماعية.. رد الجميل لمجتمعك من
                خلال مساعدة الآخرين على التعلم و بناء مجتمع افضل.
              </p>
            </div>

            <div className="shifting"></div>
          </div>

          <div></div>

          <p className="centered">تعرف على فريقنا</p>
          <div className="team">
            {config.Team.map((value, index) => {
              return (
                <span className="team-member">
                  <img
                    className="member-avatar"
                    sryle=""
                    src={teamimages[index]}
                    alt={config.Team[index].name}
                  ></img>
                  <span>
                    <div className="member-name">
                      {config.Team[index].name} - {config.Team[index].role}
                    </div>
                    <div className="contact-member">
                      <a href={config.Team[index].email}>تواصل</a>{" "}
                    </div>
                  </span>
                </span>
              );
            })}
          </div>

          <div className="wtm-outer">
            <div className="shifting2"></div>

            <div className="container wtm">
              <div className="wtm-text">
                <h1> Women Techmakers</h1>
                <p>
                  هو أحد برامج جوجل , يهدف بشكل أساسي لدعم النساء و تطوير طرق
                  جديدة لزيادة الفرص المهنية و التعليمية , عن طريق تفعيل برامج
                  تدريبية مثل برنامج Public Speaking Workshops الذي يهدف إلى
                  تطوير مهارات الحديث لدى النساء وغيرها من البرامج الهادفة مثل
                  الحديث عن أهمية ال product managment و دورة في التقدم بمجال
                  الصناعة , و غيرها من الفعاليات الداعمة للمرأة مثل الحديث عن
                  .قضية المساواة في الأجور و قضايا المشاركة في مجال ريادة
                  الاعمال
                </p>
              </div>

              <img alt="wtm" className="img" src={Muxg4oO}></img>
            </div>
            <div className="shifting2"></div>
          </div>

          <h1 className="newstellerh1">اشترك بقائمتنا البريدية</h1>
          <div className="newsteller-outter">
            <div className="newsteller">
              <img alt="newsteller" className="img" src={nn}></img>

              <form
                className="formnews"
                name="contact"
                method="POST"
                data-netlify="true"
                data-netlify-honeypot="bot-field"
              >
                <input type="hidden" name="contact" value="contact" />
                <p>
                  <label>
                    الإسم <input type="text" name="name" placeholder="الإسم" />
                  </label>
                </p>
                <p>
                  <label>
                    البريد الإلكتروني
                    <input
                      placeholder="البريد الإلكتروني"
                      type="email"
                      name="email"
                    />
                  </label>
                </p>

                <p>
                  <button className="formbutton">اشترك</button>
                </p>
              </form>
              <img alt="newsteller" className="img2" src={nn2}></img>
            </div>
          </div>

          <section className="learnwithus">
            <h1>تعلم مع نادي الطلبة المطورين </h1>
            <p> </p>
            <div className="learncards">
              <Link to="/flutter-introduction">
              <div className="learncard">
                <img alt="flutter" src={flutter}></img>
                <h3>Flutter</h3>
              </div>
              </Link>
            </div>


          </section>

          <section className="section">
            <h2>
              آخر المنشورات
              <Link to="/blog" className="view-all">
                شاهد الكل
              </Link>
            </h2>
            <PostListing simple postEdges={latestPostEdges} />
          </section>
        </div>
      </Layout>
    );
  }
}

export const pageQuery = graphql`
  query IndexQuery {
    latest: allMdx(
      limit: 6
      sort: { fields: [fields___date], order: DESC }
      filter: { frontmatter: { template: { eq: "post" } } }
    ) {
      edges {
        node {
          fields {
            slug
            date
          }
          excerpt
          timeToRead
          frontmatter {
            title
            tags
            categories
            thumbnail {
              childImageSharp {
                fixed(width: 150, height: 150) {
                  ...GatsbyImageSharpFixed
                }
              }
            }
            date
            template
          }
        }
      }
    }
    popular: allMdx(
      limit: 10
      sort: { fields: [fields___date], order: DESC }
      filter: { frontmatter: { categories: { eq: "Popular" } } }
    ) {
      edges {
        node {
          fields {
            slug
            date
          }
          excerpt
          timeToRead
          frontmatter {
            title
            tags
            categories
            thumbnail {
              childImageSharp {
                fixed(width: 150, height: 150) {
                  ...GatsbyImageSharpFixed
                }
              }
            }
            date
            template
          }
        }
      }
    }
  }
`;
